export default __webpack_public_path__ + "static/mega-phone-2ec61fe70b6aa308932bfa84df61538f.webp";